import IconTrash from 'approot/shared/icons/icon-trash';
import { ButtonBaseProps } from './base-button.style';
import {
  SecondaryButtonIcon,
  SecondaryButtonIconProps,
} from './secondary-button.style';

type Props = {
  onClick: () => void;
} & SecondaryButtonIconProps &
  ButtonBaseProps;

const DeleteButtonIcon = ({ onClick, $isDisabled, ...rest }: Props) => {
  return (
    <SecondaryButtonIcon
      type="button"
      $borderRadius={8}
      $isDisabled={$isDisabled}
      onClick={onClick}
      disabled={$isDisabled}
      {...rest}
    >
      <IconTrash width={20} height={20} />
    </SecondaryButtonIcon>
  );
};

export default DeleteButtonIcon;
